import {BrowserModule, Title} from "@angular/platform-browser";
import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA,} from "@angular/core";
import {AppRoutingModule} from "./app.routing.module";
import {AppComponent} from "./app.component";
// Shared Modules
import {CommonModule} from "@angular/common";
import {SharedModule} from "./shared/shared.module";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {provideHttpClient} from "@angular/common/http";
// abs-ngx-library: ProductUtilService is NOT providedIn:'root' in the library
// build, but it is a transitive dep of root-scoped CommonService/J4uV1Service.
// Hoist it here so the root injector can resolve the full chain.
import {ProductUtilService} from 'abs-ngx-library/src/lib/core';
// SubscriptionService is not providedIn:'root'; hoist it here so the root-scoped
// ForU+ route guards can resolve it from the root injector.
import {SubscriptionService} from './shared/services/subscription.service';

@NgModule({
    declarations: [AppComponent],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        SharedModule,
        AppRoutingModule,
    ],
    exports: [],
    providers: [provideHttpClient(), Title, ProductUtilService, SubscriptionService],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {
}
